import { render, staticRenderFns } from "./PanelConsultas.vue?vue&type=template&id=e5178760&scoped=true&"
import script from "./PanelConsultas.vue?vue&type=script&lang=js&"
export * from "./PanelConsultas.vue?vue&type=script&lang=js&"
import style0 from "./PanelConsultas.vue?vue&type=style&index=0&id=e5178760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5178760",
  null
  
)

export default component.exports